import "./App.css";
import Router from "./Router";
//import { useEffect, useRef } from "react";
// Import axios instance for API calls
import axios from "axios";

//import { ToastContainer, toast } from "react-toastify";
import { ToastContainer } from "react-toastify";
//import { useNavigate } from "react-router-dom";

function App() { 
  //  axios.defaults.baseURL = "http://localhost:3000/api/v1";
  axios.defaults.baseURL = "https://funmiracles.com/api/v1";  

  return (
    <>
      <ToastContainer /> 
      <Router />
    </>
  );

  
}

export default App;